import React from 'react';

export const HomePage: React.FC = () => {
	return (
		<div />
	);
};

export default HomePage;